module.exports = __webpack_public_path__ + "img/logo-tapetum-empty.5b737b03.svg";